import { useEffect } from "react";
import activateFeature from "./activateFeature";

/**
 * @memberof module:asos-web-toggle-point-optimizely
 * @inner
 * @description Activates a feature with Optimizely as a react hook, calling [activateFeature]{@link module:asos-web-toggle-point-optimizely~activateFeature} internally.
 * @param {object} params parameters
 * @param {object} params.audience the audience that made the decisions
 * @param {external:HostApplication.sdkInstanceProvider} params.sdkInstanceProvider SDK instance provider
 * @param {Object<string, string>} params.matchedFeatures features that have been matched to point cuts in the codebase
 * @example
 * useActivation({
 *   audience,
 *   sdkInstanceProvider,
 *   matchedFeatures: {
 *     "feature-1": "variant-1",
 *     "feature-2": "control"
 *   }
 * });
 */
const useActivation = ({ audience, matchedFeatures, sdkInstanceProvider }) => {
  useEffect(() => {
    matchedFeatures.forEach(([featureName]) => {
      activateFeature({ featureName, audience, sdkInstanceProvider });
    });
  }, [matchedFeatures, audience, sdkInstanceProvider]);
};

export default useActivation;
